import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';
import { ticketDeskTable } from '../../shared/ticket/ticketDeskTable.styles'
import { ticketSurfaces } from '../../shared/ticket/ticketSurfaces.styles';

/** Shell visual compartido: Gastos (tablas, modales, sheets). Tabla PC = Catálogo. */
export const expensesTicket = StyleSheet.create({
  table: {
    ...ticketDeskTable.table,
  },
  tableEmbedded: {
    ...ticketDeskTable.tableEmbedded,
  },
  tableRow: {
    ...ticketDeskTable.row,
  },
  /** Overrides sobre `tableRow` para la fila de encabezado. */
  tableHeaderRow: {
    minHeight: 40,
    paddingVertical: 10,
    backgroundColor: ticketColors.paper2,
    borderBottomColor: ticketColors.ruleSoft,
  },
  tableHeaderCell: {
    ...ticketDeskTable.headerCell,
  },
  tableCell: {
    ...ticketDeskTable.cell,
  },
  sheetBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'flex-end',
  },
  sheetCard: {
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    paddingTop: 8,
    maxHeight: '96%',
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
    zIndex: 1,
  },
  modalCard: {
    backgroundColor: ticketColors.paper,
    borderColor: ticketColors.ruleSoft,
  },
  heroBand: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.md,
    gap: spacing.xs,
  },
  heroKicker: {
    fontSize: 11,
    fontWeight: '800',
    color: ticketColors.gold,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    fontFamily: ticketFonts.sans,
  },
  heroSubtitle: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink2,
    lineHeight: 18,
    fontFamily: ticketFonts.sans,
  },
  actionsDock: {
    flexShrink: 0,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: 20,
    paddingTop: spacing.md,
    paddingBottom: 20,
    gap: spacing.sm,
  },
});
